import { Injectable } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import * as semver from 'semver';

@Injectable({
  providedIn: 'root'
})
export class BrowserValidatorService {

  private browsers = {
    'windows': {
      'chrome': '115',
      'firefox': '115',
      'ms-edge-chromium': '115'
    },
    'mac': {
      'chrome': '115', // this cover ipad too
      'firefox': '115',
      'safari': '15' // makes it work with latest ipad
    },
    'android': {
      'chrome': '115',
      'firefox': '115',
    },
    'ios' : {
      'safari': '15',
      'chrome': '92'
    }
  };

  constructor(private deviceDetector: DeviceDetectorService) { }

  isValid() {
    const deviceInfo: DeviceInfo = this.deviceDetector.getDeviceInfo();

    // console.log(deviceInfo);
    // console.log(deviceInfo.browser);
    // console.log(deviceInfo.browser_version);
    // console.log(deviceInfo.os);
    // console.log(deviceInfo.os_version);
    // console.log(deviceInfo.userAgent);

    // ios devices report OS as mac so won't follow ios rules without a fix.
    // Following code detects for ipad / iphone and if true will hardcode ios as the os in the supported version call

    let isipad = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)


    let supportedVersion = 'false';

    if (isipad){
        //@ts-ignore
      supportedVersion = this.browsers['ios'][deviceInfo.browser.toLowerCase()];

      // console.log('apparently ipad and supportedVersion is: ', supportedVersion);
    }
    else{
        //@ts-ignore
      supportedVersion = this.browsers[deviceInfo.os.toLowerCase()][deviceInfo.browser.toLowerCase()];
      // console.log('apparently not ipad and supportedVersion is: ', supportedVersion);
    }
    //const supportedVersion = this.browsers[deviceInfo.os.toLowerCase()][deviceInfo.browser.toLowerCase()];

    // console.log(semver.coerce(deviceInfo.browser_version), semver.coerce(supportedVersion));


    //@ts-ignore
    // console.log(supportedVersion, semver.gte(semver.coerce(deviceInfo.browser_version), semver.coerce(supportedVersion)));
    //@ts-ignore
    return supportedVersion && semver.gte(semver.coerce(deviceInfo.browser_version), semver.coerce(supportedVersion));

  }
}

